import React, { useState, useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import ExtensionIcon from '@mui/icons-material/Extension';

import MyButton from '@common/components/Button/MyButton';
import MultiLIneInput from '@common/components/MultiLineInput/MultiLIneInput';
import TextWithPlaceholdersModal from '@resolvers/tools/TextWithPlaceholdersModal/TextWithPlaceholdersModal';
import { useTemplateDetailsStore } from '@store/templateDetailsStore';

const TextWithPlaceholderInput = ({
  value,
  setValue,
  placeholder,
  helperText,
  label,
  spaceDisabled,
  sx = {},
}) => {
  const source = useTemplateDetailsStore((s) => s.source);
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState({
    show: false,
    listSource: '',
    parent: '',
    showRootFields: true,
    action: null,
  });
  const inputRef = useRef();

  const insertAtCursor = (inputElement, currentValue, insertText) => {
    const start = inputElement.selectionStart;
    const end = inputElement.selectionEnd;

    const before = currentValue.slice(0, start);
    const after = currentValue.slice(end);

    const newValue = before + insertText + after;

    return {
      value: newValue,
      cursorPos: start + insertText.length,
    };
  };

  const handleInsert = (selectedPlaceholder) => {
    const input = inputRef.current;
    const insertText = `{{${selectedPlaceholder}}}`;

    const { value: newValue } = insertAtCursor(input, value, insertText);

    setValue(newValue);
  };

  const showOnModal = () => {
    setShowModal({
      show: true,
      listSource: '',
      parent: '',
      showRootFields: true,
      action: null,
    });
  };

  const isSpaceActionDisabled = (e) => {
    if (!spaceDisabled) return false;
    return e.key == ' ' || e.code == 'Space' || e.keyCode == 32;
  };

  const placeholderRegex = /\{\{[^{}]*\}\}/g;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || isSpaceActionDisabled(e)) {
      e.preventDefault();
    }
    if (e.key !== 'Backspace' && e.key !== 'Delete') return;

    const input = inputRef.current;
    const cursorPos = input.selectionStart;

    const matches = [...value.matchAll(placeholderRegex)];

    for (const match of matches) {
      const placeholder = match[0];
      const startIdx = match.index;
      const endIdx = startIdx + placeholder.length;

      const isBackspaceInRange =
        e.key === 'Backspace' && cursorPos > startIdx && cursorPos <= endIdx;

      const isDeleteInRange =
        e.key === 'Delete' && cursorPos >= startIdx && cursorPos < endIdx;

      const isEdgeCase =
        (e.key === 'Backspace' && cursorPos === startIdx) ||
        (e.key === 'Delete' && cursorPos === endIdx);

      if (isBackspaceInRange || isDeleteInRange || isEdgeCase) {
        e.preventDefault();

        const newValue = value.slice(0, startIdx) + value.slice(endIdx);
        setValue(newValue);

        setTimeout(() => {
          input.setSelectionRange(startIdx, startIdx);
        }, 0);

        return;
      }
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    // ovde se setuje subject
    // updateTemplateState('emailSubject', e.target.value);
  };

  return (
    <Box sx={sx}>
      <TextWithPlaceholdersModal
        documentJson={source?.structure || {}}
        showModal={showModal}
        setShowModal={setShowModal}
        handleInsert={handleInsert}
      />
      <MultiLIneInput
        inputRef={inputRef}
        label={label}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        helperText={helperText}
      />
      <MyButton onClick={showOnModal} startIcon={<ExtensionIcon />}>
        {t('add_placeholder')}
      </MyButton>
    </Box>
  );
};

export default TextWithPlaceholderInput;
